// 코인 이름 지정
export const COIN_NAME_TRI = 'TRI' as const;
export const COIN_NAME_SFL = 'SFL' as const;
export const COIN_NAME_NFT = 'NFT' as const;
export const COIN_NAME_METIC = 'MATIC' as const;
export const COIN_NAME_USDT = 'USDT' as const;

export const NOT_CONNECT = 'contractAddress not find';

// private 코인 이름
export const COIN_NAME_PRIVATE_TOKEN1 = 'CTF1' as const;
export const COIN_NAME_PRIVATE_TEST2 = 'test2' as const;
export const COIN_NAME_PRIVATE_TEST3 = 'test3' as const;
export const COIN_NAME_PRIVATE_TEST4 = 'test4' as const;
export const COIN_NAME_PRIVATE_TEST5 = 'test5' as const;
